import { render, staticRenderFns } from "./AddCopyTemplate.vue?vue&type=template&id=76a9cd21&scoped=true"
import script from "./AddCopyTemplate.vue?vue&type=script&lang=js"
export * from "./AddCopyTemplate.vue?vue&type=script&lang=js"
import style0 from "./AddCopyTemplate.vue?vue&type=style&index=0&id=76a9cd21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a9cd21",
  null
  
)

export default component.exports